export const INSTANT_WITHDRAWAL_MAX_AMOUNT = 50000000;
